import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { TemplatePortfolioWizard } from "@/components/template-portfolio/TemplatePortfolioWizard";
import { requireModule } from "@/lib/module-access";

export const Route = createFileRoute("/_authed/campaigns/template-portfolio")({
  beforeLoad: () => {
    requireModule("campaigns");
  },
  // Invalid values degrade to a fresh start rather than an error page.
  validateSearch: z.object({
    step: z
      .union([z.literal(1), z.literal(2), z.literal(3), z.literal(4), z.literal(5)])
      .optional()
      .catch(undefined),
    shopId: z.string().uuid().optional().catch(undefined),
    draftId: z.string().uuid().optional().catch(undefined),
    executionId: z.string().uuid().optional().catch(undefined),
  }),
  component: TemplatePortfolioWizard,
});
